// t() reads the page language, which the compiler cannot see, and this stays
// on screen while the language changes.
"use no memo";
import {
  AvatarDialog,
  EditProfileDialog,
  LogoutDialog,
} from "../account/account-dialogs";
import { EnterDialog } from "../account/enter-dialog";
import {
  SettingsDialog,
  SignInDialog,
  SoundsDialog,
} from "../account/settings-dialog";
import { KeepDialog } from "../links/guest-call";
import type { CallNotifications } from "../notifications/use-call-notifications";
import { AddFriendDialog } from "../people/add-friend-dialog";
import {
  PersonDialog,
  RequestsDialog,
  SafetyDialog,
} from "../people/person-dialogs";
import { GroupFriendsDialog } from "../group-calls/group-friends-dialog";
import type { Dialog } from "./shell";

export function OpenDialog({
  dialog,
  notifications,
}: {
  dialog: Dialog;
  notifications: CallNotifications;
}) {
  switch (dialog.kind) {
    case "group-friends":
      return <GroupFriendsDialog />;
    case "enter":
      return <EnterDialog step={dialog.step} target={dialog.target} />;
    case "keep":
      return <KeepDialog />;
    case "person":
      return (
        <PersonDialog
          person={dialog.person}
          code={dialog.code}
          search={dialog.search}
        />
      );
    case "requests":
      return <RequestsDialog />;
    case "safety":
      return <SafetyDialog person={dialog.person} action={dialog.action} />;
    case "add-friend":
      return <AddFriendDialog step={dialog.step} />;
    case "settings":
      return <SettingsDialog notifications={notifications} />;
    case "sounds":
      return <SoundsDialog />;
    case "sign-in":
      return <SignInDialog />;
    case "edit":
      return <EditProfileDialog />;
    case "avatar":
      return <AvatarDialog />;
    case "logout":
      return <LogoutDialog />;
  }
}
